var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpotCleaningNavigatorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25.987mm",
    height: "26.013mm",
    viewBox: "0 0 25.987 26.013",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79.11 .26491)",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5875
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: "1.58px",
      stroke: "rgb(112, 112, 112)",
      transformOrigin: "-0.889999px 12.786px",
      fill: "rgb(255, 255, 255)"
    },
    cx: 92.01,
    cy: 12.835,
    rx: 12.088,
    ry: 12.088
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 84.064 6.475 L 91.871 20.852 L 94.459 3.038 L 101.764 15.477 C 100.412 20.768 94.483 23.99 89.417 22.532 C 84.472 21.109 80.57 15.882 82.389 9.381",
    fill: "none",
    stroke: "#6FCF89",
    strokeLinecap: "round",
    strokeOpacity: 0.75,
    strokeWidth: 1.5712,
    style: {}
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotCleaningNavigatorIcon);
export default __webpack_public_path__ + "static/media/SpotCleaningNavigatorIcon.749a32986b476e9d02e5b30e75388aec.svg";
export { ForwardRef as ReactComponent };